import PropTypes from "prop-types";
import React from "react";
import info from "icons/info-new-rows.svg";

const getRowsAddedText = (currentCount, previousCount) => {
  const rowsAdded = currentCount - previousCount;
  const totalRows = ` - Total Rows ${currentCount}`;
  if (rowsAdded === 0) {
    return `No new rows added ${totalRows}`;
  }
  if (rowsAdded === 1) {
    return `1 new row added ${totalRows}`;
  }
  if (rowsAdded === -1) {
    return `1 row removed ${totalRows}`;
  }
  if (rowsAdded > 1) {
    return `${rowsAdded} new rows added ${totalRows}`;
  }
  if (rowsAdded < 1) {
    return `${Math.abs(rowsAdded)} rows removed ${totalRows}`;
  }
  return "";
};

const RowsAddedInfo = ({ count, previousLength, isLoading }) => {
  return (
    <div className="rows_added" data-testid="rows-added-info">
      <img src={info} alt="info" />
      <span style={{ fontSize: "9px" }}>
        {isLoading ? "Calculating..." : getRowsAddedText(count, previousLength)}
      </span>
    </div>
  );
};

export default React.memo(RowsAddedInfo);

RowsAddedInfo.propTypes = {
  count: PropTypes.number,
  previousLength: PropTypes.number,
  isLoading: PropTypes.bool,
};
